import type { CommerceTranslation } from './types';

/** Arabic (Modern Standard). Pending review by native speakers. */
export const commerceAr: CommerceTranslation = {
  nav: { orders: 'الطلبات', finance: 'استثناءات مالية' },
  orders: {
    title: 'الطلبات',
    description:
      'طلبات تمت في المحادثة. حالات الدفع والاسترداد تأتي من مزوّد الدفع، لا من المحادثة.',
    search: 'ابحث برقم الطلب',
    needsAttention: 'الطلبات التي تحتاج إلى متابعة فقط',
    empty: 'لا توجد طلبات بعد.',
    emptyFiltered: 'لا توجد طلبات مطابقة.',
    clearFilters: 'عرض كل الطلبات',
    loading: 'جارٍ تحميل الطلبات',
    columns: {
      reference: 'الطلب',
      customer: 'العميل',
      placed: 'تاريخ الطلب',
      total: 'الإجمالي',
      payment: 'الدفع',
      fulfilment: 'التنفيذ',
      attention: 'يحتاج إلى متابعة',
    },
    visitor: 'زائر',
    pendingRefunds_one: 'استردادات بانتظار القرار: {{count}}',
    pendingRefunds_other: 'استردادات بانتظار القرار: {{count}}',
    openExceptions_one: 'استثناءات: {{count}}',
    openExceptions_other: 'استثناءات: {{count}}',
  },
  payment: {
    not_started: 'غير مدفوع',
    requires_action: 'بانتظار العميل',
    processing: 'قيد التأكيد',
    authorized: 'مصرّح به',
    captured: 'مدفوع',
    failed: 'فشل',
    cancelled: 'ملغى',
    unknown: 'غير مؤكد',
  },
  orderState: {
    draft: 'مسودة',
    submitted: 'بانتظار الدفع',
    confirmed: 'مؤكد',
    partially_fulfilled: 'نُفّذ جزئيًا',
    fulfilled: 'نُفّذ',
    cancel_requested: 'طُلب الإلغاء',
    cancelled: 'ملغى',
    returned: 'مُرتجع',
  },
  fulfilment: {
    not_started: 'لم يبدأ',
    pending: 'قيد الانتظار',
    in_progress: 'قيد التنفيذ',
    delayed: 'متأخر',
    shipped: 'شُحن',
    delivered: 'سُلّم',
    provisioned: 'مُفعّل',
    failed: 'فشل',
    cancelled: 'ملغى',
  },
  detail: {
    loading: 'جارٍ تحميل الطلب',
    back: 'كل الطلبات',
    title: 'الطلب {{reference}}',
    observed: 'قُرئ من السجلات في {{time}}.',
    seller: 'البائع',
    customer: 'العميل',
    items: 'المنتجات',
    delivery: 'التوصيل',
    total: 'الإجمالي',
    payment: 'الدفع',
    paidAt: 'وقت الدفع',
    providerRef: 'مرجع المزوّد',
    paid: 'المدفوع',
    refunded: 'المسترد',
    refundable: 'ما زال قابلًا للاسترداد',
    fulfilments: 'التنفيذ',
    noFulfilment: 'لا توجد تحديثات تنفيذ بعد.',
    estimate: 'تقدير المتجر: {{date}}',
    kind: { shipment: 'شحنة', service: 'خدمة' },
    source: { merchant: 'من نظام المتجر', staff: 'سجّله الفريق' },
    tracking: 'رقم التتبع: {{ref}}',
    updated: 'آخر تحديث {{time}}',
    operations: 'طلبات إلى المزوّد',
    operationsDescription: 'كل طلب إلى مزوّد الدفع، مع ما لوحظ ومن أين ومتى.',
    operationState: {
      pending: 'لم يُرسل',
      dispatched: 'أُرسل',
      succeeded: 'تم',
      failed: 'فشل',
      unknown: 'النتيجة غير معروفة بعد',
      cancelled: 'ملغى',
    },
    receipt: '{{kind}} · {{outcome}} · {{source}} · {{time}}',
    exceptions: 'الاستثناءات',
  },
  fulfilmentForm: {
    open: 'تسجيل تحديث',
    title: 'تسجيل تحديث عن التنفيذ',
    description: 'سجّل ما أبلغ عنه المتجر. يرى العميل الحالة الجديدة في المحادثة.',
    kind: 'ما الذي يتم تنفيذه',
    state: 'الحالة الجديدة',
    estimate: 'الموعد المتوقع',
    estimateHint: 'فقط موعد قدّمه المتجر. يراه العميل تقديرًا وليس وعدًا.',
    carrierRef: 'رقم التتبع',
    note: 'ملاحظة للفريق',
    noteHint: 'لا يرى العميل هذه الملاحظة.',
    submit: 'حفظ وإبلاغ العميل',
    saved: 'تم حفظ التحديث. يراه العميل في المحادثة.',
  },
  refunds: {
    title: 'المبالغ المستردة',
    none: 'لا توجد مبالغ مستردة بعد.',
    request: 'طلب استرداد',
    requestDescription: 'يمكن استرداد ما يصل إلى {{amount}}.',
    policyAlways: 'كل استرداد يحتاج إلى موافقة شخص ثانٍ.',
    policyThreshold: 'الاسترداد الذي يزيد على {{amount}} يحتاج إلى موافقة شخص ثانٍ.',
    amount: 'المبلغ بعملة {{currency}}',
    fullOnly: 'يستطيع هذا المتجر رد المبلغ كاملًا فقط: {{amount}}.',
    amountHint: 'مثل 35.00',
    ambiguous: 'أي مبلغ تقصد؟',
    invalid: {
      empty: 'أدخل مبلغًا.',
      format: 'أدخل مبلغًا مثل 35.00.',
      precision: 'منازل عشرية كثيرة جدًا لعملة {{currency}}.',
      negative: 'أدخل مبلغًا أكبر من صفر.',
      too_large: 'هذا المبلغ كبير جدًا.',
      over: 'هذا أكثر مما يمكن استرداده.',
    },
    reason: 'السبب',
    reasons: {
      customer_request: 'طلب العميل',
      damaged: 'تالف',
      not_delivered: 'لم يُسلّم',
      duplicate: 'خُصم مرتين',
      other: 'آخر',
    },
    note: 'ملاحظة للفريق',
    submit: 'طلب الاسترداد',
    state: {
      requested: 'مطلوب',
      policy_checked: 'تم التحقق',
      awaiting_approval: 'بانتظار الموافقة',
      submitted: 'أُرسل إلى المزوّد',
      pending: 'قيد المعالجة لدى المزوّد',
      succeeded: 'تم الاسترداد',
      rejected: 'مرفوض',
      failed: 'فشل',
      unknown: 'النتيجة غير مؤكدة',
    },
    requestedBy: 'طلبه {{name}}، {{time}}',
    approvedBy: 'وافق عليه {{name}}، {{time}}',
    rejectedBy: 'رفضه {{name}}: {{reason}}',
    failureReason: 'قال المزوّد: {{reason}}',
    approve: 'الموافقة على الاسترداد',
    reject: 'رفض',
    check: 'التحقق من حالة الاسترداد',
    approveTitle: 'الموافقة على استرداد {{amount}}؟',
    approveBody: 'يعود المبلغ إلى وسيلة دفع العميل عبر مزوّد الدفع. لا يمكن التراجع عن ذلك من هنا.',
    approveConfirm: 'الموافقة والإرسال',
    rejectTitle: 'رفض هذا الاسترداد؟',
    rejectReason: 'لماذا؟ (يراه الفريق)',
    rejectConfirm: 'رفض الاسترداد',
    samePerson: 'أنت من طلب هذا الاسترداد، لذا يجب أن يوافق عليه شخص آخر.',
    noPermission: 'يقرر هذا فقط من يستطيع الموافقة على الاسترداد.',
    separateApprover: 'يجب أن يوافق على هذا الاسترداد شخص غير الذي طلبه.',
    pendingNote: 'لا يُعدّ مستردًا حتى يؤكده المزوّد.',
  },
  finance: {
    title: 'استثناءات مالية',
    description:
      'مدفوعات ومبالغ مستردة تحتاج نتيجتها إلى شخص. التحقق يسأل المزوّد مرة أخرى. الحلّ يسجّل قرارك ولا يحرّك أي مبلغ.',
    open: 'مفتوحة',
    resolved: 'محلولة',
    tabs: 'عرض',
    empty: 'لا شيء يحتاج إلى متابعة.',
    emptyResolved: 'لا توجد استثناءات محلولة بعد.',
    loading: 'جارٍ تحميل الاستثناءات',
    kind: {
      payment_unknown: 'نتيجة الدفع غير معروفة',
      refund_unknown: 'نتيجة الاسترداد غير معروفة',
      order_update_pending: 'مدفوع، لكن الطلب لم يُحدّث',
      amount_mismatch: 'المبلغ مختلف',
      reconcile_exhausted: 'المزوّد لا يجيب',
      refund_failed: 'فشل الاسترداد',
      provisioning_failed: 'لم تُفعّل الخدمة',
    },
    action: {
      check_status: 'تحقق من الحالة',
      wait_for_provider: 'انتظر المزوّد',
      contact_provider: 'تواصل مع المزوّد',
      review_order: 'راجع الطلب',
      retry_refund: 'تحقق، ثم أعد الاسترداد إن لزم',
    },
    nextAction: 'الخطوة الآمنة التالية: {{action}}',
    providerState: 'حالة المزوّد: {{state}}',
    openedAt: 'مفتوح منذ {{time}}',
    evidence: 'الأدلة',
    order: 'الطلب {{reference}}',
    check: 'التحقق مع المزوّد',
    resolve: 'حلّ',
    resolveTitle: 'حلّ هذا الاستثناء',
    resolution: 'الحل',
    resolutions: {
      provider_confirmed: 'أكد المزوّد النتيجة',
      manual_review: 'رُوجع يدويًا',
      refunded_elsewhere: 'استُرد بطريقة أخرى',
      written_off: 'شُطب',
    },
    note: 'ما الذي تحققت منه',
    resolveConfirm: 'حلّ الاستثناء',
    resolvedAs: 'حُلّ: {{resolution}}',
  },
};
